module.exports = __webpack_public_path__ + "img/O.f2c03ec0.svg";